import {combineReducers} from "redux";
import shopShareReducer from "@atg-shop-shared/shops-domain-redux/src/shopShareReducer";
import {modalsReducer as modals} from "@atg-shared/modals-data-access";
import {activeBreakpoint} from "atg-match-media/domain/matchMediaReducer";
import toasts from "atg-ui-toast/domain/toastReducer";
import {limitsReducer as limits} from "@atg-responsible-gambling-shared/limits-domain";

const createRootReducer = () =>
    combineReducers({
        activeBreakpoint,
        alert: () => window._frameStore.getState().alert,
        auth: () => window._frameStore.getState().auth,
        accessToken: () => window._frameStore.getState().accessToken,
        limits,
        modals,
        toasts,
        router: () => window._frameStore.getState().router,
        kycQuestionnaire: () => window._frameStore.getState().kycQuestionnaire,
        user: () => window._frameStore.getState().user,
        shop: combineReducers({
            shopShare: shopShareReducer,
        }),
    });

export default createRootReducer;
